var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 27,
    viewBox: "0 0 17 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0903 14.8571L14.9841 25.515C15.0053 25.6405 14.9877 25.7694 14.9336 25.8847C14.8796 25.9999 14.7916 26.0958 14.6815 26.1597C14.5714 26.2236 14.4445 26.2523 14.3176 26.2421C14.1907 26.2319 14.07 26.1832 13.9716 26.1025L9.49643 22.7436C9.28039 22.5822 9.01795 22.495 8.74828 22.495C8.47861 22.495 8.21617 22.5822 8.00013 22.7436L3.51748 26.1012C3.41913 26.1818 3.29855 26.2304 3.17184 26.2407C3.04512 26.2509 2.9183 26.2223 2.80828 26.1586C2.69827 26.0949 2.61029 25.9991 2.55609 25.8841C2.5019 25.7691 2.48405 25.6404 2.50494 25.515L4.39751 14.8571M16.2442 8.74439C16.2442 12.8867 12.8862 16.2446 8.7439 16.2446C4.60163 16.2446 1.24365 12.8867 1.24365 8.74439C1.24365 4.60212 4.60163 1.24414 8.7439 1.24414C12.8862 1.24414 16.2442 4.60212 16.2442 8.74439Z",
    stroke: "#EF7F1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessment);
export default __webpack_public_path__ + "static/media/assessment.eba21c6cb26ca43707e4b5b95a9234db.svg";
export { ForwardRef as ReactComponent };